import { error } from "@sveltejs/kit";

import type { PageLoad } from "./$types";

export const prerender = "auto";

export const load: PageLoad = async ({ params }) => {
  let module;
  if (params.id) {
    try {
      module = await import(`../../../../../lib/docs/examples/${params.id}.svx`);
    } catch (_) {
      try {
        module = await import(
          `../../../../../../generated/examples-md/${params.id}.md`
        );
      } catch (_) {
        error(404);
      }
    }
  }
  return {
    content: module.default,
    ogTitle: module.metadata.meta.title,
    ogDescription: module.metadata.meta.description,
    ogImageUrl:
      "https://modal.com/docs/social-image.png?" +
      new URLSearchParams({
        title: module.metadata.meta.title,
        socialType: "docs",
      }),
    title: module.metadata.meta.title + " | Modal Docs",
  };
};
